@if (!editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:my-2">
      <div class="tw:w-auto tw:px-[15px]">
        <div class="kvp__k tw:py-1">Observation Type:</div>
        <div class="kvp__k tw:py-1">Observation:</div>
      </div>
      <div class="tw:flex-1 tw:px-[15px]">
        <div class="kvp__v tw:py-1">{{ timelineSection.observationType }} &nbsp;</div>
        <div class="kvp__v tw:py-1">{{ timelineSection.observationDescription }} &nbsp;</div>
      </div>
    </div>
  </div>
}


@if (editMode) {
  <div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
      <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2">
        <label class="field__label">Observation Type:</label>
        <select class="field__control" [(ngModel)]="timelineSection.observationType" name="type" [disabled]="!isFormEditable()">
          @for (observationType of observationTypes; track observationType) {
            <option [ngValue]="observationType.text">{{observationType.text}}</option>
          }
        </select>
      </div>
    </div>
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
      <div class="tw:w-full tw:px-[15px]">
        <label class="field__label">
          Observation:
          @if (!(timelineSection.observationDescription && timelineSection.observationDescription.length > 0)) {
            <i class="tw:text-danger font-10">(mandatory)</i>
          }
        </label>
        <textarea required #lessonSummary
          class="field__control"
          [(ngModel)]="timelineSection.observationDescription"
          [disabled]="!isFormEditable()"
          name="description"
          rows="7"
          maxlength="3000"></textarea>
        <span class="field__hint tw:block tw:text-right">{{ timelineSection.observationDescription?.length || 0 }}/3000</span>
      </div>
    </div>
  </div>
}
